export const logoPath = "/carefleet-logo-cropped.png";

export const guardianLoginUrl = "https://guardian-fleet-uk.preview.emergentagent.com";

export const navItems = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Platform", path: "/platform" },
  { label: "Procurement", path: "/procurement" },
  { label: "Schools", path: "/schools" },
  { label: "Families", path: "/families" },
  { label: "Safeguarding", path: "/safeguarding" },
  { label: "Contact", path: "/contact" },
];

export const homepageStats = [
  { label: "Live journey visibility", value: "Real-time" },
  { label: "Safeguarding controls", value: "Audit-ready" },
  { label: "Stakeholder access", value: "Role-based" },
];

export const platformModules = [
  {
    title: "Trips",
    value: "Illustrative journey board",
    detail: "Live status, planned arrivals, and route oversight from one dashboard.",
  },
  {
    title: "Vehicles",
    value: "Example vehicle readiness view",
    detail: "Structured assignment, driver readiness, and service coverage visibility.",
  },
  {
    title: "Incidents",
    value: "Illustrative incident workflow",
    detail: "Logged, timestamped, and traceable through a clear operational workflow.",
  },
  {
    title: "Live tracking",
    value: "Example live oversight",
    detail: "Location snapshots, milestones, and handover checkpoints in real time.",
  },
];

export const roleBenefits = [
  {
    title: "Admin",
    summary: "Operational control across routes, vehicles, incidents, and accountability.",
  },
  {
    title: "Driver",
    summary: "Structured workflows for pickups, handovers, and secure status updates.",
  },
  {
    title: "Parent",
    summary: "Reassurance through clear visibility, journey milestones, and proactive communication.",
  },
  {
    title: "School",
    summary: "Coordination support with reliable arrival visibility and incident communication.",
  },
];

export const footerStatement = "Human care powered by digital control.";

export const contactDetails = [
  {
    label: "Email",
    value: "hello@carefleettransport.co.uk",
    href: "mailto:hello@carefleettransport.co.uk",
  },
  {
    label: "Phone",
    value: "0330 000 0000",
    href: "tel:03300000000",
  },
  {
    label: "Coverage",
    value: "UK specialist transport support for councils, schools, and families.",
    href: null,
  },
];

export const journeySignals = [
  "Live tracking and milestone updates",
  "Digital handover verification",
  "Incident logging with audit trail",
  "Clear oversight for parents, schools, and councils",
];